<div style="width: 100%; height: 100%; display: flex; flex-direction: column;">
    <div class="card-header">
        <div class="card-header-content">
            @if (!hasNoData) {
                <ng-content select="[card-header-content-primary]"></ng-content>
                <div class="card-header-skeleton-loader" style="width: 220px;">
                    <div class="skeleton" style="padding: 10px; border-radius: 5px; margin: -10px;">
                        <div class="fg-2"></div>
                        <div class="fg"></div>
                        <div class="fg-2"></div>
                    </div>
                </div>
            }
            @else {
                <ng-content select="[card-header-no-content]"> </ng-content>
            }
        </div>
    </div>
    <div class="card-body">
        <div class="card-body-content">
            @if (!hasNoData) {
                <ng-content select="[card-body-content-chart]"></ng-content>
                <ng-content select="[card-body-content-legend]"></ng-content>
            }
            @else {
                <div card-body-no-content>
                    <div class="container">
                        <div class="primary-text" style="display: flex; flex-direction: row;">
                            <span><i class="fa-duotone fa-file-circle-minus icon" style="padding-right: 10px;"></i></span>
                            <div>
                                <div class="no-content-message">There's nothing to display yet.</div>
                               <ng-content select="[card-no-content-button]"></ng-content>
                            </div>
                        </div>
                    </div>
                </div>
            }

        </div>        
    </div>
</div>

